import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { StyledWatchListButton } from './Styles';
import Icon from '../Icon';

const propTypes = {
  isWatchlisted: PropTypes.bool,
  variant: PropTypes.oneOf(['fullsize', 'mini', 'fullsize_reverse']),
  toggleWatchlist: PropTypes.func
};

const defaultProps = {
  isWatchlisted: false,
  variant: 'fullsize',
  toggleWatchlist: () => {}
};

const WatchButton = ({ variant, isWatchlisted, toggleWatchlist }) => {
  return (
    <StyledWatchListButton
      data-testid="watchList"
      variant={variant}
      isWatchlisted={isWatchlisted}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        toggleWatchlist();
      }}
    >
      <Icon icon={isWatchlisted ? `TR5-Watched` : `TR5-Watch`} />
      {variant !== 'mini' && (
        <FormattedMessage id={isWatchlisted ? 'vdp.watched' : 'vdp.watch'} />
      )}
    </StyledWatchListButton>
  );
};

WatchButton.propTypes = propTypes;
WatchButton.defaultProps = defaultProps;

export default WatchButton;
